// extracted by mini-css-extract-plugin
export default {"menuList":"Menu_menuList__o1Gh7","menuItem":"Menu_menuItem__QXQhR"};